import { render, staticRenderFns } from "./ModalBan.vue?vue&type=template&id=d8d18bbe&scoped=true"
import script from "./ModalBan.vue?vue&type=script&lang=js"
export * from "./ModalBan.vue?vue&type=script&lang=js"
import style0 from "./ModalBan.vue?vue&type=style&index=0&id=d8d18bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d18bbe",
  null
  
)

export default component.exports